import { render, staticRenderFns } from "./InputMethodBehaviorEditor.vue?vue&type=template&id=40a90a64&"
import script from "./InputMethodBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./InputMethodBehaviorEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports